import BaseImg from './base-img'

export default BaseImg